import * as React from 'react';
import ReactTable, {RowInfo} from 'react-table';
import {connect} from 'react-redux';
import * as AlertModule from 'Modules/AlertModule';
import * as Dictionary from 'Models/Dictionary';
import {injectThProps, checkPageQuery, AlertSubBlock, OnOff, NotifyCell, Filter, Cell} from 'HelperFunctions/Lists';
import {createSerachQuery} from 'Connectors/_main';
import {withTranslation, WithTranslation} from 'react-i18next';

type P = {
    //
};

type ConnectedP = {
    alertStore: AlertModule.Types.AlertStore;
};
type DispatchedP = {
    getUsersAlertsWithLoaderMain: (urlQuery?: URLSearchParams) => Function;
    setActiveAlert: (alert: AlertModule.Types.AlertDefinitionDto) => Function;
    enablingAlert: (alertId: number, alertEnabledValue: boolean) => Function;
};
type S = {
    activeSorting: string;
    activeFilter: string;
    page: number;
    selected: number;
    expanded: Object;
};

class AlertList extends React.Component<P & ConnectedP & DispatchedP & WithTranslation, S> {
    constructor(props: any) {
        super(props);
        this.state = {
            activeSorting: '',
            activeFilter: '',
            page: 0,
            selected: null,
            expanded: {}
        };
        this.getFilteredData = this.getFilteredData.bind(this);
    }

    private alertName = Filter.InputTextFilter.bind(this, this.props.t('alertName'), true);

    public async componentDidMount() {
        await this.props.getUsersAlertsWithLoaderMain();
    }

    private getFilteredData(filters: Array<{ id: any; value: any }>) {
        const urlQuery = createSerachQuery(filters);
        this.props.getUsersAlertsWithLoaderMain(urlQuery);
    }

    private async manageAlertEnabling(alertId: number, value: boolean) {
        await this.props.enablingAlert(alertId, value);
    }

    private handleRowExpanded = (newExpanded, index, event) => {
        if (!this.state.expanded[index]) {
            this.setState({expanded: {[index]: true}});
        } else {
            this.setState({expanded: {[index]: false}});
        }
    };
    private getTrProps = (state: any, rowInfo: RowInfo) => {
        return {
            onClick: () => {
                this.setState({selected: rowInfo.index});
                this.props.setActiveAlert(rowInfo.original);
            },
            className: rowInfo ? (rowInfo.index === this.state.selected ? 'active' : '') : ''
        };
    };

    public render() {
        const {alertStore, t} = this.props;
        const {SPEEDING} = AlertModule.EnumTypes.AlertCondition;
        const pageSize = 20;
        const pages = alertStore.alertDefinitions ? Math.ceil(alertStore.alertDefinitions.length / pageSize) : 1;
        return (
            <div className="main__content main__content--no-padding">
                <div className="table__content">
                    <ReactTable
                        // className="reactTable vehicleList--table vehicleList--nomaxheight alertList"
                        data={alertStore.alertDefinitions ? [...alertStore.alertDefinitions] : []}
                        expanded={this.state.expanded}
                        pages={pages}
                        page={this.state.page}
                        getTheadThProps={injectThProps}
                        defaultPageSize={alertStore.alertDefinitions ? (alertStore.alertDefinitions.length > pageSize ? pageSize : 0) : pageSize}
                        pageSize={alertStore.alertDefinitions ? (alertStore.alertDefinitions.length > pageSize ? pageSize : 0) : pageSize}
                        getTrProps={this.getTrProps}
                        onExpandedChange={this.handleRowExpanded}
                        SubComponent={row => <AlertSubBlock alertDto={row.original}/>}
                        onPageChange={page => this.setState({page})}
                        onFetchData={(state, instance) => {
                            const query = checkPageQuery(state.filtered, state.page);
                            this.getFilteredData(query);
                        }}
                        columns={[
                            {
                                expander: true,
                                Header: 'hiddenHeader',
                                className: 'cell',
                                width: (window.innerWidth > 1280) ? 65 : 30,
                                Expander: Cell.Expander
                            },
                            {
                                Header: 'hiddenHeader',
                                id: 'priority',
                                className: 'cell cell--align-center',
                                accessor: 'priority',
                                filterable: false,
                                width: 40,
                                Cell: props => <img src={Dictionary.PriorityIcons.get(props.value)} width={14} alt=""/>
                            },
                            {
                                Header: 'hiddenHeader',
                                id: 'enabled',
                                className: 'cell cell--align-center',
                                accessor: 'enabled',
                                filterable: false,
                                width: 43,
                                Cell: props => <OnOff isOn={props.value}
                                                      onClick={(item: boolean) => this.manageAlertEnabling(props.original.id, props.value)}/>
                            },
                            {
                                Header: 'hiddenHeader',
                                id: 'name',
                                className: 'cell',
                                accessor: 'name',
                                Filter: this.alertName
                            },
                            {
                                Header: 'hiddenHeader',
                                id: 'alertCondition',
                                accessor: 'alertCondition',
                                className: 'cell',
                                Filter: () => <div
                                    className="filter__title filter__title--left">{t('alertCondition')}</div>,
                                Cell: props => (
                                    <span>
                                    {Dictionary.AlertConditionDictionaryMap.get(props.value)} {props.value === SPEEDING ? ` > ${props.original.conditionValue}` : ''}
                                </span>
                                )
                            },
                            {
                                Header: 'hiddenHeader',
                                id: 'message',
                                className: 'cell',
                                accessor: 'message',
                                Filter: () => <div
                                    className="filter__title filter__title--left">{t('alertNotifyType')}</div>,
                                Cell: notifyData => <NotifyCell notifyData={notifyData}/>
                            }
                        ]}
                    />
                </div>
            </div>
        );
    }
}

function mapStateToProps(state: any): ConnectedP {
    return {
        alertStore: state.alertStore
    };
}

function mapDispachToProps(dispatch: any): DispatchedP {
    return {
        getUsersAlertsWithLoaderMain: (urlQuery?: URLSearchParams) => dispatch(AlertModule.Actions.getUsersAlertsWithLoaderMain(urlQuery)),
        enablingAlert: (alertId: number, alertEnabledValue: boolean) => dispatch(AlertModule.Actions.enablingAlert(alertId, alertEnabledValue)),
        setActiveAlert: (alert: AlertModule.Types.AlertDefinitionDto) => dispatch(AlertModule.Actions.setActiveAlert(alert))
    };
}

export default withTranslation('forms')(
    connect(
        mapStateToProps,
        mapDispachToProps
    )(AlertList) as React.ComponentType<any>
);



// WEBPACK FOOTER //
// ./src/components/Alerts/AlertList.tsx